import Tabs from './Tabs';
import TabList from './TabList';
import Tab from './Tab';
import TabPanel from './TabPanel';
import TabLink from './TabLink';
import TabLinkList from './TabLinkList';
import tabsStyles from './tabs.module.scss';

export {
  Tabs,
  TabList,
  Tab,
  TabPanel,
  TabLink,
  TabLinkList,
  tabsStyles,
};

export default Tabs;
